import Container from '@admin/components/container'
import Preview from '@admin/components/preview'
import PropTypes from 'prop-types'
import Sidebar from './sidebar'
import Canvas from './canvas'
import Header from './header'
import React from 'react'

export const devices = [
  { value: 'desktop', label: 'Desktop' },
  { value: 'tablet', label: 'Tablet', height: 1024 , width: 768 },
  { value: 'mobile', label: 'Mobile', height: 667, width: 375 }
]

class SignupPageDesigner extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    endpoint: PropTypes.string,
    version: PropTypes.object,
    onChange: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {}
  }

  state = {
    device: 'desktop',
    orientation: 'portrait',
    initial: null,
    config: null
  }

  _handleDevice = this._handleDevice.bind(this)
  _handleOrientation = this._handleOrientation.bind(this)
  _handleSave = this._handleSave.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    if(!this.state.config) return null
    return (
      <div className="maha-signup-page-designer">
        <div className="maha-signup-page-designer-main">
          <Header { ...this._getHeader() } />
          <Preview { ...this._getPreview() }>
            <Canvas { ...this._getCanvas() } />
          </Preview>
        </div>
        <Sidebar { ...this._getSidebar() } />
      </div>
    )
  }

  componentDidMount() {
    this._handleFetch()
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getCanvas() {
    const { config } = this.state
    const { version } = this.props
    return {
      config,
      version
    }
  }

  _getHeader() {
    const { device, orientation } = this.state
    return {
      device,
      devices,
      orientation,
      onDevice: this._handleDevice,
      onOrientation: this._handleOrientation
    }
  }

  _getPreview() {
    const { device, orientation } = this.state
    return {
      device,
      devices,
      orientation
    }
  }

  _getSidebar() {
    const { config, initial } = this.state
    return {
      config,
      dirty: !_.isEqual(config, initial),
      onChange: this._handleUpdate,
      onSave: this._handleSave
    }
  }

  _handleDevice(device) {
    this.setState({ device })
  }

  _handleOrientation(orientation) {
    this.setState({ orientation })
  }

  _handleFetch() {
    const { endpoint } = this.props
    this.context.network.request({
      endpoint,
      method: 'GET',
      onSuccess: ({ data }) => {
        this._handleSet(data.signup_page_config)
      },
      onFailure: () => {}
    })
  }

  _handleSave(signup_page_config) {
    const { endpoint } = this.props
    this.context.network.request({
      endpoint,
      method: 'PATCH',
      body: {
        signup_page_config
      },
      onSuccess: () => {
        this.setState({
          initial: signup_page_config
        })
      },
      onFailure: () => {}
    })
  }

  _handleChange() {
    const { config } = this.state
    this.props.onChange({
      name: config.name,
      message: config.message,
      headshot: config.headshot ? {
        asset_id: config.headshot.asset.id,
        transforms: config.headshot.transforms
      } : null
    })
  }

  _handleSet(config) {
    this.setState({ 
      config: config || {},
      initial: config || {}
    })
  }

  _handleUpdate(config) {
    this.setState({ 
      config
    })
  }

}

const mapResources = (props, context) => ({
  version: `/api/admin/maha_signup_pages/${props.signup_page_id}/config/versions/published`
})

export default Container(mapResources)(SignupPageDesigner)
